var module = angular.module('octopusApp.shared');

module.directive('identitiesListing', function (busy, octopusRepository, octopusClient, $uibModal, unsavedChanges) {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      identities: '='
    },
    templateUrl: 'areas/shared/views/identities-listing.html',
    link: function (scope) {
      var isLoading = scope.isLoading = busy.create();

      isLoading.promise(octopusRepository.UserIdentityMetadata.all().then(function(metadata) {
        scope.metadata = metadata;

        var providers = octopusClient.rootDocument().AuthenticationProviders;
        scope.anyEnabledIdentityProviders = _.some(scope.metadata.Providers, function (p) { return _.some(providers, function (a) { return a.Name === p.IdentityProviderName}); });
      }));

      scope.MapClaimLabel = function(provider, key) {
        var p = _.find(scope.metadata.Providers, function (p) { return p.IdentityProviderName === provider; });
        var v = _.find(p.ClaimDescriptors, function (d) { return d.Type == key; });
        return v.Label;
      }
      scope.MapClaimDescription = function(provider, key) {
        var p = _.find(scope.metadata.Providers, function (p) { return p.IdentityProviderName === provider; });
        var v = _.find(p.ClaimDescriptors, function (d) { return d.Type == key; });
        return v.Description;
      }

      scope.removeIdentity = function(identity) {
        unsavedChanges.unsaved();
        var ix = scope.identities.indexOf(identity);
        if (ix >= 0) {
            scope.identities.splice(ix, 1);
        }
      };

      scope.addIdentity = function() {
        return $uibModal.open({
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/shared/views/add_identity_dialog.html',
            controller: 'AddIdentityController',
            dialogClass: 'modal modal-big',
            resolve: {
              metadata: function() {
                return scope.metadata;
              }
            }
        }).result.then(function (result) {
            if (result) {
              scope.identities.push(result);
              unsavedChanges.unsaved();
            }
        });
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/identities_listing.js
// module id = 8049180084169594
// module chunks = 1